/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProfileModel } from '../models/profile-model';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation apiUsersIdentityMeGet
   */
  static readonly ApiUsersIdentityMeGetPath = '/api/users/identity/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersIdentityMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersIdentityMeGet$Response(params?: { context?: HttpContext }): Observable<StrictHttpResponse<ProfileModel>> {
    const rb = new RequestBuilder(this.rootUrl, UserService.ApiUsersIdentityMeGetPath, 'get');
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ProfileModel>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiUsersIdentityMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersIdentityMeGet(params?: { context?: HttpContext }): Observable<ProfileModel> {
    return this.apiUsersIdentityMeGet$Response(params).pipe(map((r: StrictHttpResponse<ProfileModel>) => r.body as ProfileModel));
  }

  /**
   * Path part for operation acceptPrivacyPolicy
   */
  static readonly AcceptPrivacyPolicyPath = '/api/users/accept-privacy-policy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acceptPrivacyPolicy()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptPrivacyPolicy$Response(params?: { context?: HttpContext }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, UserService.AcceptPrivacyPolicyPath, 'post');
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `acceptPrivacyPolicy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptPrivacyPolicy(params?: { context?: HttpContext }): Observable<void> {
    return this.acceptPrivacyPolicy$Response(params).pipe(map((r: StrictHttpResponse<void>) => r.body as void));
  }
}
